module.exports = __webpack_public_path__ + "static/media/sistema-reservas-plano-starter.6e842ed3.png";